import { useAuthStore } from '../../../../stores';

const EXPANDS = [
    'brand.ecommerce_account',
    'activation',
    'files',
    'content_rights',
    'orders.items',
    'orders.address',
    'tasks',
    'product_configs.items.category',
    'product_configs.items.items',
    'product_configs.items.items.category',
    'custom_fields',
    'contact_properties',
    'payment_configs',
    'payables',
    'tracking_tags',
    'conversion_configs',
    'deliverables',
    'deliverables.content',
    'deliverables.last_approval_content_activity',
    'deliverables.last_approval_content_activity.content',
    'deliverables.last_approval_content_activity.content.files',
    'payables',
    'creator_licensing_configs',
    'network_content_requests',
];
const BRIEF_EXPANDS = EXPANDS.map((resource) => 'expand[]=' + resource).join('&');

export default {
    data() {
        return {
            isPatchingBrief: false,
            isCompletingBrief: false
        };
    },
    computed: {
        briefUrl() {
            //@TODO: create mixin to encode query data
            return `/api/v1/contacts/${this.contactId}/activation-briefs/${this.briefParamId}?${BRIEF_EXPANDS}`;
        },
        briefCompleteUrl() {
            return `/api/v1/contacts/${this.contactId}/activation-briefs/${this.briefParamId}/complete?${BRIEF_EXPANDS}`;
        },
        briefRestartUrl() {
            return `/api/v1/contacts/${this.contactId}/activation-briefs/${this.briefParamId}/restart`;
        },
        briefParamId() {
            return this.$route.params.brief_id;
        },
        brief() {
            return this.$root.v2.brief;
        },
        affiliateLinks() {
            return this.$root.v2.affiliateLinks;
        },
        discountCodes() {
            return this.$root.v2.discountCodesList;
        }
    },
    methods: {
        newDraftBriefUrl(briefId, contactId) {
            return `/api/v1/contacts/${contactId}/activation-briefs/${briefId}?${BRIEF_EXPANDS}`;
        },
        loadActivationBrief(force = false) {
            if (this.brief && !force) {
                return Promise.resolve();
            }

            return this.$http
                .get(this.briefUrl)
                .then((res) => {
                    this.$root.v2.brief = res.data;
                })
                .catch(this.handleHttpError);
        },
        loadNewDraftActivationBrief(briefId, contactId) {
            return this.$http
                .get(this.newDraftBriefUrl(briefId, contactId))
                .then((res) => {
                    this.$root.v2.brief = res.data;
                    return res.data;
                })
                .catch(this.handleHttpError);
        },
        updateBriefState(brief) {
            this.$root.v2.brief = brief;
        },
        completeBrief() {
            this.resetErrors();
            this.isCompletingBrief = true;

            return this.$http
                .patch(this.briefCompleteUrl)
                .then((response) => {
                    this.updateBriefState(response.data);
                    return response;
                })
                .then(() => {
                    this.isCompletingBrief = false;
                })
                .catch(() => this.handleHttpError(error));
        },
        restartBrief() {
            this.isLoading = true;
            return this.$http
                .post(this.briefRestartUrl)
                .then(() => {
                    return this.$router.push({ name: 'v2.activation.brief.overview' });
                })
                .then(() => {
                    this.isLoading = false;
                    location.reload();
                })
                .catch((error) => {
                    this.isLoading = false;
                    this.handleHttpError(error);
                });
        },
        loadAffiliateLinks() {
            this.$root.v2.affiliateLinks = [];
            const affiliateLinkUrl = `/api/v1/contacts/${this.contactId}/activation-briefs/${this.briefParamId}/affiliate-links`;
            return this.$http
                .get(affiliateLinkUrl)
                .then((res) => {
                    this.$root.v2.affiliateLinks.push(...res.data);
                    return res;
                })
                .catch(this.handleHttpError);
        },
        loadDiscountCodes() {
            this.$root.v2.discountCodesList = [];
            const discountCodeUrl = `/api/v1/contacts/${this.contactId}/activation-briefs/${this.briefParamId}/discount-codes`;
            return this.$http
                .get(discountCodeUrl)
                .then((res) => {
                    this.$root.v2.discountCodesList.push(...res.data);
                    return res;
                })
                .catch(this.handleHttpError);
        },
        needsVerification() {
            return this.$root.account_makes_payments && this.brief.has_module_payments && !useAuthStore().isLoggedIn;
        },
        createDraftBrief(activationId, contactId) {
            return this.$http
            .post(`/api/v1/contacts/${contactId}/activations/${activationId}/draft-brief`)
            .then((res) => {
                this.$root.v2.brief = res.data;
                return res.data;
            });
        }
    }
};
